import { defaultColumns, defaultSort } from '../../components/sales/representativeOrders/columns';

export default {
  state: {
    representativeOrders: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    representativeOrders: state => state.representativeOrders,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setRepresentativeOrders(state, representativeOrders) {
      state.representativeOrders = representativeOrders;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/representative-order-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'representative-order-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const representativeOrders = await axios.get('api/representative-orders' + (query || ''));
        commit('setRepresentativeOrders', representativeOrders);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/representative-orders/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/representative-orders/${id}`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/representative-orders/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async create({ commit }, payLoad) {
      await axios.post('api/representative-orders', payLoad);
    },
    async send({ commit }, id) {
      return await axios.post(`api/send-representative-orders/${id}`);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/representative-orders', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/representative-orders/${id}`);
    },
    async resign({ commit }, id) {
      await axios.put(`api/representative-orders/resign/${id}`);
    },
    async undoResignation({ commit }, id) {
      await axios.put(`api/representative-orders/undo-resignation/${id}`);
    },
    async fetchRemainingOrders({ commit }, id) {
      return await axios.get(`api/representative-orders/remaining-orders`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/representative-order-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'RepresentativeOrders'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
